import { BrowserRouter } from 'react-router-dom';
import { Router } from './router';
import { NotificationProvider } from './features/notifications/context/NotificationProvider';
import { AuthProvider } from './features/auth/context/AuthProvider';

export function App() {
  return (
    <BrowserRouter>
      {/*
       * Ordre important :
       * 1. BrowserRouter : requis par AuthProvider (useNavigate)
       * 2. NotificationProvider : disponible pour AuthProvider et tous ses descendants
       * 3. AuthProvider : initialise le token depuis localStorage, expose login/logout ;
       *    sur HTTP 401, useFetch renouvelle le jeton (POST /auth/refresh) et ne termine
       *    la session que si le renouvellement échoue (HOMCO-1269)
       */}
      <NotificationProvider>
        <AuthProvider>
          <Router />
        </AuthProvider>
      </NotificationProvider>
    </BrowserRouter>
  );
}
